import { gql } from '@apollo/client';

const orderOnline = {
  ORDER_ONLINE: gql`
    query OrderOnlineExternal(
      $selectedCar: SelectedCarForDeal!
      $financeFormInput: FinanceFormInput
      $postCode: String
    ) {
      orderOnlineExternal(selectedCar: $selectedCar, financeFormInput: $financeFormInput, postCode: $postCode)
    }
  `,
};

export default orderOnline;
